<template>
  <div>
    <div class="list-actions text-right">
      <span class="icon-action" @click="exportPayouts">
        <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
      </span>
    </div>

    <div class="panel no-padding" v-if="tableData.length > 0">
      <searchBar placeholder="Search payouts" @sort="sort" :value="searchValue"
                 @search="search"></searchBar>

      <div :class="['loading-area', loading ? 'loading' : '']">
        <div :class="['loading-area__content', loading ? 'loading' : '']">
          <pagination :prev="prev" :next="next" :start="start" :end="end"
                      :total="total"
                      @paginate="paginate"></pagination>

          <tableList :header="tableHeader" :data="tableData" :loading="loading"
                     @callback="callback" @post="go"
                     @sort="orderBy"></tableList>

          <pagination :prev="prev" :next="next" :start="start" :end="end"
                      :total="total"
                      @paginate="paginate"></pagination>
        </div>
      </div>
    </div>

    <div class="panel" v-if="tableData.length === 0">
      <p>Vendor does not currently have any payouts.</p>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

import moment from 'moment'
import axios from 'axios'

export default {
  mixins: [client, paginationUtils],
  props: [
    'vendor_id'
  ],
  data: function () {
    return {
      action: '/vendors/payouts/?vendor_id=' + this.vendor_id,
      sort: '-created_date',
      tableHeader: {
        currentSort: '-amount',
        data: [
          {
            label: 'Amount',
            class: 'medium',
            sort: 'amount',
            sortStart: '-'
          },
          {
            label: 'Note',
            class: 'full'
          },
          {
            label: 'Date',
            class: 'large',
            sort: 'created_date',
            sortStart: '-'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportPayouts () {
      this.request('get', '/vendors/payouts/', {
        vendor_id: this.vendor_id,
        page_size: 1000,
        ordering: '-created_date',
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        let data = encodeURI(response)

        downloadLink.href = '/download/?' + data
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
    },
    downloadReport (id) {
      axios({
        method: 'post',
        url: 'https://vendorconsignment.visceralapps.com/vendors/export-payout/?id=' + id
      }).then((response) => {
        if (response.status === 200) {
          let link = document.createElement('a')
          link.download = 'payout.pdf'
          link.href = 'https://vendorconsignment.visceralapps.com/static/reports/payout.pdf'
          link.target = '_blank'
          link.textContent = 'Download payouts.csv'

          link.click()
        }
      })
    },
    go: function (id) {
      this.$router.push('/payouts/' + id)
    },
    buildTable () {
      if (this.$store.state.shop.myshopify_domain === 'celebrityowned.myshopify.com' || this.$store.state.shop.myshopify_domain === 'visceral-apps-staging.myshopify.com') {
        this.tableHeader.data.push({
          label: '',
          class: 'medium'
        })
      }

      for (let i = 0; i < this.data.length; i++) {
        let row = {
          post: this.data[i].id,
          data: [
            {
              value: this.formatMoney(this.data[i].amount),
              class: 'medium focus-text'
            },
            {
              value: this.data[i].note,
              class: 'full'
            },
            {
              value: moment(this.data[i].created_date).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            }
          ]
        }

        if (this.$store.state.shop.myshopify_domain === 'celebrityowned.myshopify.com' || this.$store.state.shop.myshopify_domain === 'visceral-apps-staging.myshopify.com') {
          row.data.push({
            value: '<button class="button--small">Report</button>',
            class: 'medium',
            callback: 'downloadReport',
            callbackArgs: [this.data[i].id]
          })
        }

        this.tableData.push(row)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/payouts.vue